/* The Snout - account panel. The header's account button opens a side panel (like the cart)
   instead of leaving the website. Without this script the button still goes to /account. */
(function () {
  'use strict';
  if (window.SnoutAccount) return;
  window.SnoutAccount = true;
  var d = document;
  var root, panel, opener, timer;

  function els() {
    root = d.querySelector('[data-sn-account]');
    panel = root ? root.querySelector('.sn-acct__panel') : null;
    return !!panel;
  }
  function lock(on) {
    d.documentElement.classList.toggle('sn-acct-lock', on);
  }
  function open(btn) {
    if (!els()) return false;
    opener = btn || null;
    clearTimeout(timer);
    root.hidden = false;
    void root.offsetWidth;
    root.classList.add('is-open');
    lock(true);
    d.querySelectorAll('[data-sn-account-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    panel.focus({ preventScroll: true }); // the panel itself takes focus; Tab moves into its links
    return true;
  }
  function close() {
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    lock(false);
    d.querySelectorAll('[data-sn-account-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    timer = setTimeout(function () { root.hidden = true; }, 420);
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }

  d.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    var btn = t.closest('[data-sn-account-toggle]');
    if (btn) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // new tab still works
      if (open(btn)) e.preventDefault();
      return;
    }
    if (t.closest('[data-sn-account-close]')) { e.preventDefault(); close(); }
  });

  d.addEventListener('keydown', function (e) {
    if (!root || root.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(panel.querySelectorAll('a[href], button'), function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && (d.activeElement === a || d.activeElement === panel)) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && d.activeElement === z) { e.preventDefault(); a.focus(); }
  });

  // Coming back with the browser's back button: start closed
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && els()) { root.classList.remove('is-open'); root.hidden = true; lock(false); }
  });
})();
